class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      if (this.domNodes.hamburgerButtons.classList.contains("active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
      this.domNodes.hamburgerButtons.classList.toggle("active");
    });
    this.domNodes.backDrop.addEventListener("click", (e) => {
      this.closeMenu();
    });
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(".m-megamenu-mobile");
      const backBtn = item.querySelector(".m-menu-mobile__back-button");

      if (subMenuContainer) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parentNode = e.target.parentNode;
            if (
              e.target.classList.contains("m-menu-mobile__back-button") ||
              parentNode.classList.contains("m-menu-mobile__back-button")
            ) {
              return;
            }

            this.openSubMenu(subMenuContainer, level);
          },
        });
      }

      if (backBtn) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parentNode = e.target.parentNode;
            if (
              e.target.classList.contains("m-menu-mobile__back-button") ||
              parentNode.classList.contains("m-menu-mobile__back-button")
            ) {
              return;
            }

            this.openSubMenu(subMenuContainer, level);
          },
        });
        backBtn.addEventListener("click", (e) => {
          const level = e.target.dataset.level;
          this.closeSubMenu(subMenuContainer, level);
        });
      }
    });

    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = true;
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

    setTimeout(() => {
      megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
      });
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons.classList.remove("active");
      // Close search
    }, this.transitionDuration);
    this.open = false;
  }

  openSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    const currentItem = subMenuContainer.closest(".m-menu-mobile__item");
    const siblingItems = currentItem.parentElement.children;
    [...siblingItems].forEach((item) => {
      if (item !== currentItem) {
        const openedMenu = item.querySelector(
          `.m-megamenu-mobile--level-${level}.open`
        );
  
        if (openedMenu) {
          openedMenu.classList.remove("open");
  
          // סוגר גם ילדים פנימיים
          openedMenu
            .querySelectorAll(".m-megamenu-mobile.open")
            .forEach((child) => {
              child.classList.remove("open");
            });

          openedMenu
            .querySelectorAll(".active_mobile_item_link")
            .forEach((el) => {
              el.classList.remove("active_mobile_item_link");
            });
  
          item.classList.remove("active_mobile_item_link");
        }
      }
    });
    
    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    subMenuContainer.classList.add("open");

    const parentItem = subMenuContainer.closest(".m-menu-mobile__item");
    parentItem.classList.add("active_mobile_item_link");
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");

    const parentItem = subMenuContainer.closest(".m-menu-mobile__item");
    parentItem.classList.remove("active_mobile_item_link");

    if (level === "1") {
      const innerMenus = subMenuContainer.querySelectorAll(
        ".m-megamenu-mobile"
      );
  
      innerMenus.forEach((menu) => {
        menu.classList.remove("open");
      });
  
      const activeItems = subMenuContainer.querySelectorAll(
        ".active_mobile_item_link"
      );
  
      activeItems.forEach((el) => {
        el.classList.remove("active_mobile_item_link");
      });
    }
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const panelHeight = window.innerHeight - offsetBottom;

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}
const readCssLength = (element, property, fallback) => {
  const raw = getComputedStyle(element).getPropertyValue(property).trim();
  if (!raw) return fallback;

  const value = parseFloat(raw);
  if (Number.isNaN(value)) return fallback;
  if (raw.endsWith("rem")) {
    return value * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
  return value;
};

class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
    window.addEventListener("resize", this.onWindowResize);
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));

      const subMenu = menuItem.querySelector(this.selectors.subMenu);
      if (subMenu) {
        subMenu.addEventListener("mouseleave", (evt) => this.onSubMenuLeave(evt, menuItem, index));
      }
    });
  };

  deactivateOtherMegaItems = (activeMenuItem) => {
    this.container &&
      this.container.querySelectorAll(".m-menu__item--mega.m-menu__item--active").forEach((item) => {
        if (item === activeMenuItem) return;
        item.classList.remove("m-menu__item--active");
        this.resetMegaMenuPosition(item);
      });
  };

  scheduleMenuClose = (menuItem, index) => {
    clearTimeout(this.timeoutLeave);
    this.lastActiveIndex = index;

    this.timeoutLeave = setTimeout(() => {
      if (!menuItem.classList.contains("m-menu__item--active")) return;
      this.closeMenuItem(menuItem);
    }, 120);
  };

  closeMenuItem = (menuItem) => {
    if (!menuItem) return;

    menuItem.classList.remove("m-menu__item--active");
    this.resetMegaMenuPosition(menuItem);

    const hasActiveMegaItem =
      this.container &&
      this.container.querySelector(".m-menu__item--mega.m-menu__item--active");

    if (!hasActiveMegaItem) {
      this.activeIndex = -1;
      this.visited = false;
      this.resetMegaMenu();
    }
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;
    const menuItem = target.closest(".m-menu__item--mega");

    if (!menuItem) return;

    clearTimeout(this.timeoutLeave);
    this.deactivateOtherMegaItems(menuItem);
    this.activeIndex = menuItem.dataset && Number(menuItem.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(menuItem);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(menuItem).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(menuItem.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        menuItem.classList.add("m-menu__item--active");
        this.positionMegaMenuToTrigger(menuItem);
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    const menuItem = evt.currentTarget;
    const related = evt.relatedTarget;

    if (related && menuItem.contains(related)) {
      return;
    }

    if (!menuItem.classList.contains("m-menu__item--mega")) {
      return;
    }

    this.scheduleMenuClose(menuItem, index);
  };

  onSubMenuLeave = (evt, menuItem, index) => {
    const related = evt.relatedTarget;

    if (related && menuItem.contains(related)) {
      return;
    }

    this.scheduleMenuClose(menuItem, index);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  positionMegaMenuToTrigger = (menuItem) => {
    if (!menuItem) return;

    const subMenu = menuItem.querySelector(this.selectors.subMenu);
    const link = menuItem.querySelector(".m-menu__link--main");
    if (!subMenu || !link) return;

    const isRTL = document.documentElement.getAttribute("dir") === "rtl";
    subMenu.style.removeProperty("transform");
    subMenu.style.left = isRTL ? "auto" : "0";
    subMenu.style.right = isRTL ? "0" : "auto";

    requestAnimationFrame(() => {
      const linkRect = link.getBoundingClientRect();
      const menuRect = subMenu.getBoundingClientRect();
      const containerBounds = (
        menuItem.closest(".m-header__container") ||
        menuItem.closest(".m-header__main") ||
        document.documentElement
      ).getBoundingClientRect();
      const padding = 20;
      const minLeft = Math.max(containerBounds.left, padding);
      const maxRight = Math.min(containerBounds.right, window.innerWidth - padding);
      const triggerGap = readCssLength(menuItem, "--mega-menu-trigger-gap", 6);

      const alignMenu = (anchor) => {
        const edgeOffset = anchor === "right" ? -triggerGap : triggerGap;

        if (anchor === "right") {
          return (
            (isRTL ? linkRect.right - menuRect.right : linkRect.left - menuRect.left) +
            edgeOffset
          );
        }
        return (
          (isRTL ? linkRect.left - menuRect.left : linkRect.right - menuRect.right) + edgeOffset
        );
      };

      let anchor = isRTL ? "right" : "left";
      let translateX = alignMenu(anchor);
      subMenu.style.transform = `translateX(${translateX}px)`;

      requestAnimationFrame(() => {
        let adjusted = subMenu.getBoundingClientRect();

        if (isRTL && adjusted.left < minLeft) {
          anchor = "left";
          translateX = alignMenu(anchor);
          subMenu.style.transform = `translateX(${translateX}px)`;
          adjusted = subMenu.getBoundingClientRect();
        } else if (!isRTL && adjusted.right > maxRight) {
          anchor = "right";
          translateX = alignMenu(anchor);
          subMenu.style.transform = `translateX(${translateX}px)`;
          adjusted = subMenu.getBoundingClientRect();
        }

        let clampX = 0;
        if (adjusted.left < minLeft) {
          clampX = minLeft - adjusted.left;
        } else if (adjusted.right > maxRight) {
          clampX = maxRight - adjusted.right;
        }

        if (clampX !== 0) {
          translateX += clampX;
          subMenu.style.transform = `translateX(${translateX}px)`;
        }
      });
    });
  };

  resetMegaMenuPosition = (menuItem) => {
    const subMenu = menuItem && menuItem.querySelector(this.selectors.subMenu);
    if (!subMenu) return;
    subMenu.style.removeProperty("transform");
    subMenu.style.removeProperty("left");
    subMenu.style.removeProperty("right");
  };

  onWindowResize = () => {
    const activeItem = this.container && this.container.querySelector(".m-menu__item--active.m-menu__item--mega");
    if (activeItem) {
      this.positionMegaMenuToTrigger(activeItem);
    }
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    window.removeEventListener("resize", this.onWindowResize);
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}
